export const emailNotificationConfigs = {
  daily: '毎日',
  weekly: '毎週',
  monthly: '毎月'
}